import { useMutation } from '@tanstack/react-query';
import { apiFetch, useError } from './api';

export const acknowledgeDashboardExplanation = async (payload = {}) => {
  await apiFetch(`${process.env.REACT_APP_API_URL}/api/explain`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};

export const useExplainMutation = (options = {}) => {
  const { checkError } = useError();
  const { onError, ...mutationOptions } = options;

  return useMutation({
    mutationFn: acknowledgeDashboardExplanation,
    ...mutationOptions,
    onError: (error, variables, context) => {
      checkError(error);
      onError?.(error, variables, context);
    },
  });
};
